import { Box, Button, ButtonGroup, ClickAwayListener, Popper, MenuList, MenuItem } from '@mui/material';
import * as React from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import '../../theme/partials/DropdownMenu.css';

type Props = {
  options: { text: string; value: any }[];
  onChange: (value: number) => void;
  startIcon?: React.ReactNode | null;
  defaultText?: string;
};

const DropdownLink: React.FC<React.PropsWithChildren<Props>> = ({ onChange, options, defaultText, startIcon }) => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [showDefaultText, setShowDefaultText] = React.useState(false);

  const handleMenuItemClick = (index: number) => {
    setSelectedIndex(index);
    setShowDefaultText(true);
    setOpen(false);
    onChange(index);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  return (
    <Box sx={{ pl: { sm: 1 } }}>
      <Box>
        <ButtonGroup disableRipple className="filter-btn-group-link">
          <Button
            onClick={handleToggle}
            // sx={{ ml: '-5px' }}
            startIcon={startIcon}
            variant="text"
            ref={anchorRef}
            className="filter-btn-group-link"
            endIcon={<ArrowDropDownIcon sx={{ ml: '-5px' }} />}
            size="small"
          >
            {defaultText && !showDefaultText ? defaultText : options[selectedIndex].text}
          </Button>
        </ButtonGroup>
      </Box>

      <Box sx={{ position: 'relative' }}>
        {open ? <div className="styled-dropdown-triangle"></div> : <></>}
        <Popper
          style={{ maxHeight: '300px', overflow: 'auto' }}
          open={open}
          anchorEl={anchorRef.current}
          placement="bottom-start"
          className="filter-box"
          modifiers={[
            {
              name: 'flip',
              options: {
                enabled: false,
                fallbackPlacements: [],
              },
            },
          ]}
        >
          <ClickAwayListener onClickAway={handleClose}>
            <MenuList className="text-dropdown-list">
              {options.map((option, index) => (
                <MenuItem dense disableRipple key={index} selected={index === selectedIndex} onClick={() => handleMenuItemClick(index)}>
                  {option.text}
                </MenuItem>
              ))}
            </MenuList>
          </ClickAwayListener>
        </Popper>
      </Box>
    </Box>
  );
};

export default DropdownLink;
